import { Button } from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { createWebhook } from '../../../../../services/manage/webhook';
import { RootState } from '../../../../../store';
import { showToast } from '../../../../utils/notifications';
import { FormSelect, MultiSelect, Section } from '../ui';
import WebhookDialog from '../ui/WebhookDialog';

interface ActionSectionProps {
    control: any;
    isBetaAccount: boolean;
    group: any;
    communicationChannel: string;
    communicationChannels: any[];
    webhookList: any[];
    memberList: any[];
    t: (key: string) => string;
    refetchWebhookList?: () => void;
}

export const ActionSection = ({ control, isBetaAccount, group, communicationChannel, communicationChannels, webhookList, memberList, t, refetchWebhookList }: ActionSectionProps) => {
    const [webhookDialogOpen, setWebhookDialogOpen] = useState(false);
    const region = useSelector((state: RootState) => state.mainReducer.region);
    const authContext = useSelector((state: RootState) => state.mainReducer.authContext);

    const handleWebhookSubmit = async (data: { url: string; name: string }) => {
        try {
            const response = await createWebhook(region, authContext.token, JSON.stringify(data));
            if (response?.result?.code === '0000') {
                showToast('success', t('created_webhook_success'));
                refetchWebhookList?.();
            } else {
                showToast('error', t('created_webhook_failed'));
            }
        } catch (error) {
            console.error('Error creating webhook:', error);
        }
    };

    return (
        <Section title={t('action')}>
            <div className="flex flex-col gap-6">
                <div className="max-w-[496px]">
                    <FormSelect name="communication_channel" label={t('select_communication_channel')} options={communicationChannels} control={control} isShrink={true} placeholder={t('select_communication_channel')} />
                </div>

                {communicationChannel === 'webhook' && (
                    <div className="flex gap-3 max-w-[496px]">
                        <MultiSelect name="slackIds" label={t('webhook')} options={webhookList} control={control} placeholder={t('select_webhook')} />
                        <Button variant="contained" className="whitespace-nowrap px-7" color="primary" onClick={() => setWebhookDialogOpen(true)}>
                            {t('add_webhook')}
                        </Button>
                    </div>
                )}

                {communicationChannel === 'group' && isBetaAccount && (
                    <div className="max-w-[496px]">
                        <MultiSelect name="groups" label={t('group')} options={group} control={control} placeholder={t('select_group')} />
                    </div>
                )}

                {communicationChannel === 'email' && (
                    <div className="max-w-[496px] flex flex-col gap-6">
                        <div className="w-full">
                            <MultiSelect name="emails" label={t('email')} options={memberList} control={control} placeholder={t('enter_email_address')} freeSolo />
                        </div>
                    </div>
                )}
            </div>

            <WebhookDialog open={webhookDialogOpen} onClose={() => setWebhookDialogOpen(false)} onSubmit={handleWebhookSubmit} />
        </Section>
    );
};
